import { get, set } from 'global/lib/lodash';
import { sortByOrderKey } from 'global/utils';

/** Scrollport id for CourseDocument — NavToTop / lesson changes target this. */
export const COURSE_DOCUMENT_SCROLL_ID = 'course-document-scroll';

export const sortDocs = (docs) => {
  return docs.sort(sortByOrderKey);
};

export const canContinue = (edoc, opts = {}) => {
  if (opts.isReview) {
    return true;
  }
  const reads = get(edoc, 'reads', []);
  return !!reads.find((r) => !!r.completedAt);
};

export const TransformDocs = (d) => {
  const data = get(d, '0', {});

  const docs = sortDocs(get(data, 'edition.documents', []));

  const docswithdividers = [];

  docs.map((doc, i) => {
    const prevDoc = docs[i - 1];

    const prevSuper = get(prevDoc, 'superset.id');

    if (!prevDoc || prevSuper !== get(doc, 'superset.id')) {
      docswithdividers.push({ id: '_divider_', title: get(doc, 'superset.name') });
    }

    docswithdividers.push(doc);
  });

  set(data, 'edition._documents', docswithdividers);

  return data;
};
